import { Dispatch } from 'redux';
import { fetchFrameDetails } from '../../../../services/discovery/fetchFrameDetails';
import { makeFetchModule } from '../../../_utils';
import { storeFrames } from '../../entities';

const callbacks = {
    onSuccess: (dispatch: Dispatch, { entities }: { entities: object }) => {
        dispatch(storeFrames(entities));
    },
};
const { reducer, fetchData, reset } = makeFetchModule(
    'app/discovery/frameDetailsFetching',
    fetchFrameDetails,
    callbacks
);

export default reducer;
export { fetchData, reset };
